// extracted by mini-css-extract-plugin
module.exports = {"logo":"RegistrationHeader_logo_3eY2z"};